import template from './radioAccordion.html';

export const radioAccordionComponent = {
  name: 'radioAccordion',
  restrict: 'E',
  transclude: true,
  template
};
